import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);

        this.menu = document.querySelector('.mobileMenu');
        this.menuToggle = this.el.querySelector('.o-navbar_menuToggle');

        this.events = {
            click: {
                open: 'openSubnav',
                openMobile: 'openSubnavMobile',
                toggleMenu: 'toggleMenu'
            }
        }
    }

    hide(){
        this.el.classList.add('-hidden');
    }

    show() {
        this.el.classList.remove('-hidden');
    }

    openSubnav(e) {
        e.preventDefault();
        let subnavId = e.currentTarget.getAttribute('data-menu');

        if (e.currentTarget.classList.contains('-active')) {
            e.currentTarget.classList.remove('-active');
        } else {
            if (this.el.querySelector('.mainMenu .-active')){
                this.el.querySelector('.mainMenu .-active').classList.remove('-active');
            }
            
            e.currentTarget.classList.add('-active');
        }

        this.call('open', subnavId, 'Subnav');
    }

    openSubnavMobile(e) {
        e.preventDefault();

        e.currentTarget.classList.toggle('-active');
    }
    
    toggleMenu() {
        if (this.menu.classList.contains('-visible')) {
            this.call('start', 'Scroll');
            this.menu.classList.remove('-visible');
            this.menuToggle.classList.remove('-active');
            this.el.classList.remove('-menu-open');
            this.menu.querySelectorAll('.-active').forEach((el) => {
                el.classList.remove('-active');
            });
        } else {
            this.call('stop', 'Scroll');
            this.menu.classList.add('-visible');
            this.menuToggle.classList.add('-active');
            this.el.classList.add('-menu-open');
        }
    }
}
